import { WSAlert, WSAlertProps } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { queriesInternalAccounts } from "@query";
import { useQueryOwnPayoutSettings } from "@hooks/useQueryOwnPayoutSettings";
import { selectorPayoutSettingsDefaultDestination } from "@selectors/selectorPayoutSettingsDefaultDestination";
import { selectorActiveBankingAccount } from "../../../shared/selectors/selectorActiveBankingAccount";

export const AlertNoPayoutMethod: React.FC = () => {
  const queryPayoutSettings = useQueryOwnPayoutSettings();
  const queryInternalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();

  const bankingAccount = queryInternalAccounts.data?.data?.find(
    selectorActiveBankingAccount
  );

  const alertProps = useMemo((): WSAlertProps | undefined => {
    const hasDefaultDestination =
      queryPayoutSettings.data &&
      !!selectorPayoutSettingsDefaultDestination(queryPayoutSettings.data);

    const hasNoPayoutMethod = !hasDefaultDestination && !bankingAccount;

    if (hasNoPayoutMethod) {
      return {
        theme: "error",
        icon: "alert",
        title: "You cannot get paid until you add a payout method"
      };
    }
  }, [bankingAccount, queryPayoutSettings.data]);

  if (queryInternalAccounts.isLoading || queryPayoutSettings.isLoading)
    return null;

  if (!alertProps) return null;

  return <WSAlert {...alertProps} />;
};
